<template>
    <div class="community-content">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="refreshing event"></spinner>
        <div class="container">
            <i aria-hidden="true" class="fa fa-5x fa-calendar" v-bind:style="{ color: getCorpHeaderColor}"></i>
            <!--<img src="../assets/community-icon.png" alt="">-->
            <h2 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important', textTransform: 'unset !important'}">{{pageTitle}}
                <br />
                <small>{{pageDesc}}</small></h2>
            <!--<div v-if="liveEventVideo">-->

                <!--<div class="row">-->
                    <!--<div class="col-sm-8 col-sm-offset-2 secondheading" v-if="liveEventVideo" >-->
                        <!--<h2 >In Case You Missed It:</h2>-->
                        <!--<p style="font-size: 16px;margin: 0 0 30px;">-->
                            <!--We get it - you're busy! So in case you missed one of our TONE Live events,-->
                            <!--we're rebroadcasting it right here.-->
                        <!--</p>-->
                        <!--&lt;!&ndash;{{getMainVideo.description}}&ndash;&gt;-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="clearfix gap"></div>-->
                <!--<div class="row">-->
                    <!--<div class="col-sm-6 col-sm-offset-3" v-if="liveEventVideo">-->
                        <!--<jwplayer  :data="liveEventVideo">Loading the player...</jwplayer>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="clearfix gap"></div>-->
                <!--<br>-->
                <!--<br>-->
            <!--</div>-->
            <div class="col-md-12 pinkbordercomp" v-if="getMainEvent && showRulesComp && showJoin(getMainEvent.eventId)">
                <rulescomp v-if="getMainEvent" :data="getMainEvent" v-bind:style="{borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpHeaderColor + ' !important'}">Loading event rules</rulescomp>
            </div>
            <div class="communityBox" v-if="getMainEvent">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6" v-if="getMainEvent">
                        <jwplayer v-if="currentVideo" :data="currentVideo">Loading the player...</jwplayer>
                        <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                        <img  v-if="!currentVideo" v-bind:src="getMainEvent.img_url" alt="MAIN EVENT BANNER" :title="getMainEvent.title">
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6" v-if="getMainEvent">
                        <h2 v-bind:style="{ color: $a11yInkColor(getCorpButtonColor) + ' !important'}"><span v-if="getMainEvent.type === '1'">TONE Live</span><span v-else>{{getMainEvent.title}}</span></h2>
                        <!-- <h2>{{getMainEvent.title}} with {{replaceLastExpert(getMainEvent.csvExpertsNames, ',', ' & ' )}}</h2> -->
                        <p v-if="getMainEvent">
                            {{getMainEvent.longDescription}}
                        </p>
                        <h5>{{getDateReference(getMainEvent.start_date, 'str')}}
                        </h5>
                        <!--<button  type="button" v-if="isUserEntrolled(getMainEvent.eventId) && isEventToday(getMainEvent.start_date, getMainEvent.end_date, getMainEvent.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>-->
                        <div v-a11y-action v-on:click="calendarLogging($event, getMainEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn"  v-if="!showJoin(getMainEvent.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">
                            Add to Calendar
                            <span class="start">{{getMainEvent.start_date}}</span>
                            <span class="end">{{getMainEvent.end_date}}</span>
                            <span class="timezone">America/New_York</span>
                            <span class="title">{{getMainEvent.title}}</span>
                            <span class="description">{{getMainEvent.longDescription}}</span>
                            <span class="location"><span v-if="getMainEvent.type === '1'">{{buildEventLink (getMainEvent.eventId) }}</span><span v-else>{{buildEventLink (getMainEvent.eventId)}}</span></span>
                        </div>
                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(getMainEvent)" type="button" class="share-event" v-bind:style="{color: $a11yInkColor(getCorpButtonColor) + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                            <i aria-hidden="true" class="fa fa-share-square-o"></i> Share
                        </button>
                        <!--<button  type="button" v-if="showJoin(getMainEvent.eventId)" @click="joinEvent(getMainEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                        <!--<button type="button" v-if="!isUserEntrolled(getMainEvent.eventId) && isEventToday(getMainEvent.start_date, getMainEvent.end_date) === false" @click="enrollUser(getMainEvent)">Reserve your spot</button>-->
                        <!--time left in event {{timeLeftInEvent(getMainEvent.start_date)}}-->
                        <!--<button type="button" >Reserve your spot starting November 13th!</button>-->
                    </div>
                </div>
                <div class="col-md-12 pinkbordercomp" v-if="getMainEvent && showRulesComp && !showJoin(getMainEvent.eventId)"  >
                    <rulescomp v-if="getMainEvent" :data="getMainEvent" v-bind:style="{borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpHeaderColor + ' !important'}">Loading event rules</rulescomp>
                </div>
            </div>
            <div class="sliderEventBox">
                <h2 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">{{liveHeading}}</h2>
                <div class="slider responsive-slick-slider">
                    <div class="col-sm-4" v-for="ev in getEventList" v-if="ev.eventId !== getMainEvent.eventId">
                        <h2 class="carosalh2" v-bind:style="{ color: $a11yInkColor(getCorpButtonColor) + ' !important'}"><span v-if="ev.type === '1'">TONE Live
</span><span v-else> {{ev.title}}</span></h2>
                        <img v-bind:src="ev.img_url" alt="EVENT BANNER" :title="ev.title" />
                        <!--<img v-bind:src="getExpertInfo(ev.expertId, 'img')" />-->
                        <h2 ><a :href="'/event/' + ev.eventId" target="new" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">{{getDateReference(ev.start_date, 'live')}} with {{replaceLastExpert(ev.csvExpertsNames, ',', ' & ' )}}</a></h2>
                        <p>
                            {{ev.longDescription}}
                        </p>
                        <h5>LIVE {{getDateReference(ev.start_date, 'live2')}} </h5>
                        <!--time left in event {{timeLeftInEvent(ev.start_date)}}-->
                        <!--<button class="button" type="button" v-if="isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date, ev.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>-->
                        <div v-a11y-action v-on:click="calendarLogging($event, ev.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn"  v-if="!showJoin(ev.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                            Add to Calendar
                            <span class="start">{{ev.start_date}}</span>
                            <span class="end">{{ev.end_date}}</span>
                            <span class="timezone">ev/New_York</span>
                            <span class="title">{{ev.title}}</span>
                            <span class="description">{{ev.longDescription}}</span>
                            <span class="location">{{buildEventLink (ev.eventId)}}</span>
                        </div>
                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(ev)" type="button" class="share-event" v-bind:style="{color: $a11yInkColor(getCorpButtonColor) + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                            <i aria-hidden="true" class="fa fa-share-square-o"></i> Share
                        </button>
                        <!--<button  class="button" type="button" v-if="showJoin(ev.eventId)" @click="joinEvent(ev)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                        <!--<button v-if="!isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date) === false" @click="enrollUser(ev)" class="button">Reserve your spot</button>-->
                    </div>
                </div>
            </div>
            <!--<div class="sliderTalkBox">-->
                <!--<h2>{{talkHeading}}</h2>-->
                <!--<p>{{talkDesc}}</p>-->
                <!--<div class="slider responsive-slick-slider">-->
                    <!--<div class="col-sm-4" v-for="evn in getTalkEvents">-->
                        <!--<h2><a :href="'/event/' + evn.eventId" target="new">{{getDateReference(evn.start_date, 'live')}}:&nbsp{{evn.title}}</a></h2>-->
                        <!--<p>-->
                            <!--{{evn.longDescription}}-->
                        <!--</p>-->
                        <!--<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>-->
                        <!--&lt;!&ndash;time left in event {{timeLeftInEvent(evn.start_date)}}&ndash;&gt;-->
                        <!--&lt;!&ndash;<span>72 Members | 302 Comments</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;<button class="button"  type="button" v-if="isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date, evn.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>&ndash;&gt;-->
                        <!--<div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(evn.eventId)">-->
                            <!--Add to Calendar-->
                            <!--<span class="start">{{evn.start_date}}</span>-->
                            <!--<span class="end">{{evn.end_date}}</span>-->
                            <!--<span class="timezone">America/New_York</span>-->
                            <!--<span class="title">{{evn.title}}</span>-->
                            <!--<span class="description">{{evn.longDescription}}</span>-->
                            <!--<span class="location">{{eventURL}}/event/{{evn.eventId}}</span>-->
                        <!--</div>-->
                        <!--&lt;!&ndash;<button class="button" type="button" v-if="showJoin(evn.eventId)" @click="joinEvent(evn)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>&ndash;&gt;-->
                        <!--&lt;!&ndash;<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>&ndash;&gt;-->
                        <!--&lt;!&ndash;<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>&ndash;&gt;-->
                        <!--&lt;!&ndash;<button type="button" class="btn disabled">Coming Soon</button>&ndash;&gt;-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <div class="sliderEventBox pointer" v-if="getLiveEventsArchive" id="missed" >
                <h2 class="archive-less-spacing" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">{{archiveHeading}}</h2>
                <p>{{archiveDesc}}</p>
                <div class="slider responsive-slick-slider">
                    <div class="col-sm-4" v-for="evn in getLiveEventsArchive" style="cursor: pointer" >
                        <div class="show-share-options" v-bind:style="{ backgroundColor: getCorpHeadingColor}"><img v-a11y-action :aria-label="evn.title" v-bind:src="evn.img_url" @click="playVideoArchive(evn.eventId, evn.title)" alt="ARCHIVE EVENT BANNER" :title="evn.title" /><div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{evn.allVidDurInMinutes}}<small>mins</small></span></div><i v-a11y-action aria-label="Play" title="Play" class="fa fa-play-circle-o" @click="playVideoArchive(evn.eventId, evn.title)"></i><i v-a11y-action aria-label="Share Playlist" v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareEventCoachingTipPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(evn)"></i></div></div>
                        <h2><button type="button" class="tone-heading-button" @click="playVideoArchive(evn.eventId, evn.title)">{{evn.title}}</button></h2>
                        <p v-a11y-action @click="playVideoArchive(evn.eventId, evn.title)">
                            {{evn.longDescription}}
                        </p>
                        <!--<button class="button" type="button" @click="playVideoArchive(evn.eventId, evn.title)"><i class="fa 2x fa-play-circle-o" aria-hidden="true"></i>&nbsp;Play&nbsp;</button>-->
                        <!--<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>-->
                        <!--time left in event {{timeLeftInEvent(evn.start_date)}}-->
                        <!--<span>72 Members | 302 Comments</span>-->
                        <!--<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>-->
                        <!--<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>-->
                        <!--<button type="button" class="btn disabled">Coming Soon</button>-->
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showSharedModal" class="watchVideoModal" effect="zoom" :value="showSharedModal" @cancel="cancelEmailShareModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelEmailShareModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="form">
                    <form method="post" id="playlistshare-form" v-on:submit.prevent="onSharePlaylist" autocomplete="off">
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                        <bs-input label="Optional Message" v-model="sharePayload.sharedEmailMessage"
                                  name="playlistshare_sharedMessage"
                                  id = "playlistshare_sharedMessage"
                                  type="text"
                                  class="form-input"
                                  error="Optional Message"
                                  placeholder="Optional Message"
                                  autocomplete="off"
                                  icon>
                        </bs-input>
                        <bs-input label="Email preview" v-model="sharePayload.sharedPlaylistPreview"
                                  name="playlistshare_sharedEmailMessagePreview"
                                  id="playlistshare_sharedEmailMessagePreview"
                                  type="textarea"
                                  disabled
                                  class="form-input"
                                  placeholder=""
                        >
                        </bs-input>
                        <button type="submit"  class="btn formButton btn-block" :disabled="spinner || (taggedEmails && taggedEmails.length === 0)">
                            Send Email
                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </form>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
<!--                <i class="fa fa-share-square-o"></i>-->
                Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p v-if="corpShareModalDesc"> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                        <p v-if="!corpShareModalDesc">{{user.firstName}}'s Personal Playlist</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button  v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) || (shareInProcess)" @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i aria-hidden="true" class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import slick from 'slick-carousel'
    import $ from 'jquery'
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    import spinner from '@/accessibility/Spinner'
    import modal from '@/accessibility/Modal'
    import input from '@/accessibility/Input'
    import rulescomp from './RulesComp.vue'
    export default {
        name: 'community',
        components: {
            jwplayer,
            'bs-input': input,
            modal: modal,
            spinner,
            rulescomp
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                shareImagePayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    eventId: '',
                    customizedMessage: '',
                    playlistType: 6
                },
                shareEventSelected: null,
                showCorporateImageShare: false,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                showShareCommunity: false,
                showShareIndividual: false,
                showShareFriends: false,
                sharePlaylistType: '',
                archiveEventId: 0,
                archiveEventTitle: '',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                toggleSpinner: false,
                showRulesComp: true,
                sharingImage: '',
                sharingTitle: '',
                sharingDescription: '',
                reservationMsg: '',
                liveEventVideo: '',
                currentVideo: null,
                videoRef: '',
                eventURL: 'https://www1.dev-tonenetworks.com',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                },
                sharePayload: {
                    tmpVideCode: '',
                    sharedEmailList: '',
                    sharedEmailMessage: '',
                    sharedPlaylistPreview: ''
                },
                shareVideoPayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    playlistId: '',
                    messageText: '',
                    playlistType: 4
                },
                pageTitle: 'TONE Talks',
                pageDesc: 'Join Our Monthly Live Stream Events And Learn From Our Experts, Executive Coaches And Each Other. These Interactive Coaching Sessions And Panels are Designed With Your Professional And Personal Growth In Mind, So Get Your Questions Ready!',
                talkHeading: 'TONE TALKS',
                talkDesc: 'oin us in our moderated discussions and tap into the wisdom of women helping women.  At TONE, we believe all women have something to share.',
                liveHeading: 'UPCOMING TONE TALKS',
                liveDesc: '',
                archiveHeading: 'IN CASE YOU MISSED IT',
                archiveDesc: 'Check out our playlists of highlights from past TONE Live events',
                metaTag_pageTitle: '',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
                // calendarLink: ''
            }
        },
        mounted: function () {
            let self = this
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
            this.$store.dispatch('GETEVENTLIST').then(() => {
                if (self.getMainEvent) {
                    console.log('hjkshdkjhsdhsdjk', self.getMainEvent)
                    self.calculateTimeToStartEvent(self.getMainEvent.start_date, self.getMainEvent.end_date, self.getMainEvent.eventSwitchTime, self.getEventSwitchTime)
                    this.$store.dispatch('GETEXPERT', this.getMainEvent.expertId).then(() => {
                        if (self.getMainEvent.type === '1') {
                            self.sharingTitle = `TONE Live: ${self.getMainEvent.title} with ${self.getExpert[0].name}`
                            self.sharingImage = self.getMainEvent.img_url
                            self.sharingDescription = self.getMainEvent.longDescription
                        } else {
                            self.sharingTitle = `TONE Talk: ${self.getMainEvent.title} with ${self.getExpert[0].name}`
                            self.sharingImage = self.getMainEvent.img_url
                            self.sharingDescription = self.getMainEvent.longDescription
                        }
                        self.$store.dispatch('CACHEPAGE', window.location.href)
                        if (self.getMainEvent.jw_stream_title && self.getMainEvent.jw_stream_title.length > 2) {
                            self.$store.dispatch('GETCURRENTVIDEO', self.getMainEvent.jw_stream_title).then(() => {
                                if (self.getCurrentVideo) {
                                    let videoObj = self.getCurrentVideo[0]
                                    self.currentVideo = {
                                        video: videoObj.sources[videoObj.sources.length - 1].file,
                                        title: videoObj.title,
                                        img: videoObj.image,
                                        playerID: new Date(),
                                        tracks: videoObj.tracks,
                                        Description: videoObj.description,
                                        mediaId: videoObj.mediaid,
                                        isMute: true
                                    }
                                    self.videoRef = window['currentVideoId']
                                }
                            })
                        }
                    })
                }
                setTimeout(() => {
                    this.createCarousal()
                }, 2000)
            })

            this.$store.dispatch('GETALLEXPERTS').then(() => {
            })
            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
            })
            this.$store.dispatch('GETEVENTSARCHIVE').then(() => {
            })
            // Get Corporatin Payload if user is part of corporation
            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                this.allCorps = []
                if (this.getCorporatePayload) {
                    this.corporateInfo = this.getCorporatePayload
                    this.allCorps = this.corporateInfo.lstCorporationUsers
                }
            })
            // Get Tagged Email List
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                if (self.getTaggedEmailList) {
                    self.emailList = []
                    self.emailList = self.getTaggedEmailList
                }
            })
            this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(() => {
                if (this.getLiveEventVideo) {
                    this.liveEventVideo = {video: this.getLiveEventVideo.sources[this.getLiveEventVideo.sources.length - 2].file, title: this.getLiveEventVideo.title, img: this.getLiveEventVideo.image, playerID: new Date(), tracks: this.getLiveEventVideo.tracks, isMute: false, showCaptions: true, autoStart: false}
                }
            })
            self.$store.dispatch('GETDYNAMICCONTENTS', 17).then(() => {
                if (self.getAllSiteContents) {
                    // Top Section
                    self.pageTitle = this.setDynamicSection(this.getAllSiteContents, 'PAGE_HEADING')
                    self.pageDesc = this.setDynamicSection(this.getAllSiteContents, 'PAGE_DESCRIPTION')
                    self.liveHeading = this.setDynamicSection(this.getAllSiteContents, 'UPCOMING LIVE EVENTS')
                    self.talkHeading = this.setDynamicSection(this.getAllSiteContents, 'TALK_HEADING')
                    self.talkDesc = this.setDynamicSection(this.getAllSiteContents, 'TALK_DESCRIPTION')
                    self.archiveHeading = this.setDynamicSection(this.getAllSiteContents, 'ARCHIVE_HEADING')
                    self.archiveDesc = this.setDynamicSection(this.getAllSiteContents, 'ARCHIVE_DESCRIPTION')
                    // SEO Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
                setTimeout(() => {
                    if (self.$route.params.section && self.$route.params.section === 'in-case-you-missed-it') {
                        $('html,body').animate({ scrollTop: $('#missed').offset().top }, 900)
                    }
                }, 3500)
            })
        },
        watch: {
            'sharePayload.sharedEmailMessage' (to, from) {
                let self = this
                let oriiginalMessage = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                if (self.showSharedModal && (self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0)) {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${oriiginalMessage}${self.sharePayload.sharedEmailMessage}`
                } else {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg} ${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            }
        },
        methods: {
            replaceLastExpert (strArray, chr, newChr) {
                console.log('---------------------------------> strArray = ', strArray)
                var a = strArray.split('')
                a[strArray.lastIndexOf(chr)] = newChr
                return a.join('').replace('/,/g', ', ')
            },
            shareCorporateImage () {
                let self = this
                self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareImagePayload.senderUserId = self.user.userId
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
                self.shareImagePayload.customizedMessage = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareImagePayload.recipientsUserIds = []
                    self.shareImagePayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareImagePayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareImagePayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareImagePayload.eventId = self.shareEventSelected.eventId
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Event has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    }
                })
            },
            openCorporateImageShareModal (tEvent) {
                console.log('event for share', tEvent)
                let self = this
                self.shareInProcess = false
                self.shareEventSelected = tEvent
                self.corpShareModalImage = tEvent.img_url
                self.corpShareModalDesc = tEvent.description
                self.corpShareModalTitle = tEvent.title
                self.showCorporateImageShare = true
            },
            cancelCorporateImageModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateImageShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            shareCorporateVideo () {
                let self = this
                self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareVideoPayload.senderUserId = self.user.userId
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = null
                self.shareVideoPayload.messageText = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareVideoPayload.recipientsUserIds = []
                    self.shareVideoPayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareVideoPayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareVideoPayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareVideoPayload.playlistId = self.archiveEventId
                // self.shareInProcess = true   commented on 09/01/2021
                // Send the Email
                if (!self.shareInProcess) {
                    self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                        if (!self.error.show) {
                            self.spinnerToggle()
                            self.$swal({
                                title: 'Playlist has been shared!',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        } else {
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        }
                    })
                }
                self.shareInProcess = true
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateShareModal (playlistObj) {
                let self = this
                self.shareInProcess = false
                self.corpShareModalImage = playlistObj.img_url
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                this.archiveEventId = playlistObj.eventId
                self.showCorporateShare = true
                // Set up user rights
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission >= 1) {
                    let rights = self.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission
                    console.log('rights', rights)
                    if (rights === 1) {
                        self.showShareCommunity = true
                        self.showShareIndividual = true
                        self.showShareFriends = true
                    } else if (rights === 2) {
                        self.showShareCommunity = true
                        self.showShareIndividual = false
                        self.showShareFriends = false
                        self.shareOption = 'Corporate'
                    } else if (rights === 3) {
                        self.showShareCommunity = false
                        self.showShareFriends = false
                        self.showShareIndividual = true
                        self.shareOption = 'Individual'
                    } else if (rights === 5) {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = true
                        self.shareOption = 'Friends'
                    } else {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = false
                    }
                }
            },
            showSharingModal (playlistObj) {
                console.log('playlist obj', playlistObj)
                let self = this
                if (self.user && self.user.corporation === null) {
                    self.openModalShare(playlistObj.eventId, playlistObj.title)
                } else {
                    self.openCorporateShareModal(playlistObj)
                }
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            cancelEmailShareModal () {
                var self = this
                var $ = window.jQuery
                self.sharePayload.tmpVideCode = ''
                self.sharePayload.sharedEmailList = ''
                self.sharePayload.sharedEmailMessage = ''
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared an event archive playlist with you on TONE Networks: \n${self.archiveEventTitle} \n`
                setTimeout(function () {
                    self.showSharedModal = false
                    self.archiveEventId = 0
                    self.archiveEventTitle = ''
                    self.sharePayload.sharedPlaylistPreview = ''
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            // addTag (newTag) {
            //     let self = this
            //     console.log('newTAg', newTag)
            //     const tag = {
            //         name: newTag
            //     }
            //     if (self.verifyEmail(newTag)) {
            //         self.emailList.push(tag)
            //         this.taggedEmails.push(tag)
            //         console.log('tagged emails', this.taggedEmails)
            //     } else {
            //         console.log('invalid email address, calling swal')
            //     }
            // },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onSharePlaylist () {
                let self = this
                self.spinnerToggle()
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle}\n${self.sharePayload.sharedEmailMessage}`
                let sharePayload = {
                    csvEmailRecepients: emailArray.join(','),
                    userId: self.user.userId,
                    playlistId: self.archiveEventId,
                    customizedMessage: self.sharePayload.sharedPlaylistPreview
                }
                self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', {payload: sharePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                            if (self.getTaggedEmailList) {
                                self.emailList = []
                                self.emailList = self.getTaggedEmailList
                                self.taggedEmails = []
                                self.sharePayload.sharedPlaylistPreview = ''
                            }
                        })
                        self.$swal({
                            title: 'Email Sent!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelEmailShareModal()
                    } else {
                        self.spinnerToggle()
                        self.cancelEmailShareModal()
                    }
                })
            },
            openModalShare (eventId, eventTitle) {
                this.archiveEventId = eventId
                this.archiveEventTitle = eventTitle
                this.showSharedModal = true
            },
            calendarLogging (event, title) {
                // console.log('event was fired', event)
                // console.log('event title', title)
                let self = this
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                userPayload.push('ADD_TO_CALENDAR')
                userPayload.push(title)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            calculateTimeToStartEvent (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let self = this
                let eventDate = new Date(evtDate)
//                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    } else {
                        let timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime
                        if (timeToStart > 0 && timeToStart <= 90) {
                            let timeToTrigger = parseInt(timeToStart * 60 * 1000)
                            setTimeout(() => {
                                self.toggleSpinner = true
                                self.showRulesComp = false
                                setTimeout(() => {
                                    self.showRulesComp = true
                                    self.toggleSpinner = false
                                }, 1500)
                            }, timeToTrigger + 60)
                        }
                    }
                }
            },
            playVideoArchive (eventId, eventTitle) {
                this.$router.push(`/tonearchive/${eventId}/play/1/${eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                // location.reload()
            },
            createCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let pHours = this.getPacificTime(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT'
                }
            },
            getExpertInfo (expertId, info) {
                let reqInfo
                if (this.getAllExperts) {
                    let expert = this.getAllExperts.filter(exp => {
                        return exp.expertId === expertId
                    })
                    if (info === 'name') {
                        reqInfo = expert[0].name
                    } else if (info === 'img') {
                        reqInfo = expert[0].small_image
                    } else if (info === 'biography') {
                        reqInfo = expert[0].biography
                    } else if (info === 'experties') {
                        reqInfo = expert[0].experties
                    }
                }
                return reqInfo
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'p.m.' : 'a.m.'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm
                return strTime
            },
            getPacificTime (time) {
                let hours = time.getHours() - 3
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'p.m.' : 'a.m.'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm
                return strTime
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            timeLeftInEvent (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                return this.getMinutesBetweenDates(currentDate, eventDate)
            },
            showJoin (eventId) {
                let event = this.getEventList.filter(evn => {
                    return evn.eventId === eventId
                })
                if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                    return true
                }
                return false
            },
            joinEvent (event) {
                this.$router.push(`/event/` + event.eventId)
            },
            enrollUser (event) {
                if (event.eventId === 1) {
                    window.logEvents('Events Page', 'Tone Live Seat Reserved', `Event Title: ${event.title}`)
                } else {
                    window.logEvents('Events Page', 'Tone Talk Seat Reserved', `Event Title: ${event.title}`)
                }
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            isHidden () {
                console.log('isHidden () = ', this.user && this.user.corporation && this.user.corporation.corporationId === 200)
                return this.user && this.user.corporation && this.user.corporation.corporationId === 200
            },
            // buildEventLink () {
            //     let href = window.location.href
            //     console.log('Community.vue : href = ', href)
            //     //
            //     let urlPartMiddleHorizonProd = '/horizonsso'
            //     let urlPartMiddleHorizonDev = '/horizonssotest'
            //     let urlPartLast = '?corporationId=200&redirect_uri='
            //     //
            //     this.eventURL = 'https://www.tonenetworks.com'
            //     if (href.indexOf('dev') > -1) {
            //         this.eventURL = 'https://www1.dev-tonenetworks.com'
            //     }
            //     if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
            //         let urlTemp = this.eventURL   // i,e. 'https://www.tonenetworks.com'
            //         if (href.indexOf('localhost') > -1) {
            //             urlTemp = 'http://localhost:8080'
            //             this.eventURL = urlTemp + urlPartMiddleHorizonDev
            //         } else if (href.indexOf('dev') > -1) {
            //             urlTemp = 'https://www1.dev-tonenetworks.com'
            //             this.eventURL = urlTemp + urlPartMiddleHorizonDev
            //         } else {
            //             this.eventURL = urlTemp + urlPartMiddleHorizonProd
            //         }
            //         this.calendarLink = this.eventURL + urlPartLast + urlTemp + '/event/' + this.getMainEvent.eventId
            //         //  https://www.tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
            //     } else {
            //         this.calendarLink = this.eventURL + '/event/' + this.getMainEvent.eventId
            //         // https://www.tonenetworks.com/event/294
            //     }
            //     return this.calendarLink
            // }
            buildEventLink (EVENT_ID) {
                let href = window.location.href
                let calendarLink = ''
                console.log('Community.vue -> buildEventLink() : href = ', href)
                console.log('Community.vue -> buildEventLink() : EVENT_ID = ', EVENT_ID)
                if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
                    if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                        calendarLink = 'https://www1.dev-tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www1.dev-tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    } else {
                        calendarLink = 'https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    }
                    //  https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
                } else {
                    calendarLink = this.eventURL + '/event/' + EVENT_ID // this.getMainEvent.eventId
                    // https://www.tonenetworks.com/event/294
                }
                return calendarLink
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getCorporatePayload', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getAllExperts', 'getUserEvents', 'getLiveEventVideo', 'getLiveEventsArchive', 'getEventSwitchTime', 'getCurrentVideo', 'getAllSiteContents', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']
            )
        }

    }
</script>
<style scoped>
    .community-content h2 {
        margin: 40px 0 50px;
    }

    h2 + button.button.btn.btn-pink.btn-primary.pull-center {
        margin: 0 auto 30px;
    }

    .community-content .communityBox h2 {
        margin:  0 0 20px;
        line-height: 1.3;
    }

    .community-content .communityBox p {
        margin: 0 0 20px;
    }
    .community-content .sliderEventBox .slick-slide img {
        object-fit: cover;
        object-position: center;
        height:auto;

    }
    @media(min-width:768px) {
        .community-content .sliderEventBox .slick-slide img {
            width: 100%;
            height: 200px;
            object-fit: cover;
            object-position: center;
        }
    }
    .community-content .secondheading h2 {
        margin: 7px 0;
    }
    .sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent {
        border-radius: 3px;
        margin: 20px 0 0;
    }

    .sliderEventBox p {
        min-height: 155px;
    }
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/
        /*background: transparent;*/
        /*color: #e08383 !important;*/
    /*}*/
    @media(min-width:768px){
        .sliderTalkBox>h2+p {
            position: relative;
            top: -40px;
            color: #303030;
            font-size: 15px;
            font-weight: 500;
            font-family: sans-serif;
            letter-spacing: 0.3px;
        }
        .community-content .sliderEventBox {
            margin: 70px 0 100px 0;
        }
        .sliderTalkBox .slider h2 {
            min-height: 62px;
        }
    }
    .community-content .communityBox button{width:auto;}
    .community-content .communityBox h5 {
        margin: 0 0 35px 0;
    }
    .community-content .sliderTalkBox .slick-slide p {
        margin: 0 0 20px 0;
        color: #303030;
        font-size: 14px;
        line-height: 22px;
        font-family: sans-serif;
        padding: 0 10px 0 10px;
        text-align: left;
        letter-spacing: 0.5px;
    }
    .selected-event {
        content: "\F00C";
        font: normal normal normal 14px/1 FontAwesome;
        position: absolute;
        color: white;
        right: 20.5px;
        top: 24px;
        font-size: 18px;
    }
    .slick-slide button.button {
        color: #f0617d;
        border: 1px solid #f0617d;
        background: none;
        outline: none;
        font-size: 16px;
        font-family: sans-serif;
        letter-spacing: 0.3px;
        float: left;
        margin-left: 10px;
        width: 278px;
        padding: 18px 15px 14px;
        border-radius: 3px;
        margin-top: 10px;
    }
    .sliderTalkBox .slider p {
        min-height: 160px;
    }
    .community-content .sliderTalkBox .slick-slide h5 {
        text-align: left;
        padding: 0 10px;
    }
    .sliderTalkBox .slider h2{
        color: #303030;
        margin: 15px 0 15px 0;
        line-height: 31px;
        text-align: left;
        font-family: sans-serif;
        padding: 0 20px 0 10px;
        font-size: 20px;
        text-transform: inherit;
    }

    *:before, *:after {
        box-sizing: border-box;
        /*color: #f0617d;*/
    }
    .slick-slide .addeventatc.pinkoutlinebtn {
        display: block;
        padding: 19px;
        margin: 10px;
        font-size: 16px;
        color: #f1214a !important;
        opacity: 1;
    }
    .community-content .communityBox .addeventatc.pinkoutlinebtn {
        margin-left: 20px;
        float: left;
    }
    .community-content .sliderEventBox h2.archive-less-spacing {
        margin: 0 0 10px;
    }
    .community-content .sliderEventBox h2.archive-less-spacing + p {
        min-height: 0;
        margin: 0 0 30px;
        color: #303030;
        font-size: 15px;
        font-weight: 500;
        font-family: sans-serif;
        letter-spacing: 0.3px;
    }
    .sliderEventBox.pointer .col-sm-4.slick-slide {
        cursor:pointer;
    }
    @media(max-width:767px){
        .community-content .communityBox .addeventatc.pinkoutlinebtn {
            margin-left: 10px;
        }
    }
    h2 svg {
        position: relative;
        top: 15px;
        width: 100px;
        height: 69px;
    }
    h2.carosalh2 {
        font-size: 25px !important;
        font-weight: 700;
    }
    .show-share-options {
        position: relative;
    }

    .show-share-options .favnumbers {
        position: absolute;
        background: #f0617d;
        top: 0;
        right: 0;
        width: 50px;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
    }

    .show-share-options .favnumbers small {
        font-size: 11px;
        display: block;
        line-height: 1;
    }

    .show-share-options .favnumbers > div {
        line-height: 1;
    }

    @media(min-width:768px){
        .show-share-options .favnumbers{
            display:none;
        }
        .show-share-options:hover .favnumbers{
            display:flex;
        }
    }
    .show-share-options .favnumbers i:before {
        color: #fff !important;
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }

    button.share-event {
        color: rgb(240, 97, 125) !important;
        border: 1px solid rgb(240, 97, 125) !important;
        background-image: none !important;
        font-weight: 600;
        line-height: 100%;
        background: #fff !important;
        font-size: 15px !important;
        text-decoration: none;
        border-radius: 3px !important;
        cursor: pointer;
        -webkit-font-smoothing: antialiased!important;
        outline-color: rgba(0,78,255,0.5) !important;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);
        display: inline-block;
        position: relative;
        /*z-index: 99998;*/
        font-family: "Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif !important;
        padding: 12px 12px 12px 12px !important;
        margin-left: 10px !important;
        width: 173px !important;
        display: inline-block;
        float: left !important;
        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;
    }
    .addeventatc.pinkoutlinebtn {
        float: left;
    }
    @media(max-width:991px){
        .community-content .communityBox .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        .community-content .communityBox button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .community-content .communityBox .addeventatc.pinkoutlinebtn{
            margin-left:15px !important;
        }
        .community-content .communityBox button.share-event{
            margin-left:15px !important;
        }
    }

    .slick-slide .addeventatc.pinkoutlinebtn {
        padding: 13px 12px 12px 37px !important;
    }

    .slick-slide button.share-event {
        width: auto !important;
        margin: 10px;
    }
    .community-content .communityBox h2 {
        /*color: #44bda8;*/
        font-size: 24px;
    }
    .community-content .communityBox {
        width: 100%;
    }
</style>
<style>

    .community-content .sliderTalkBox .slick-slide .addeventatc.pinkoutlinebtn span {
        margin: 0;
        float: none;
    }
    .watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
        top: 20px;
    }

</style>



// WEBPACK FOOTER //
// Community.vue?7e1af8ec